(function() {
'use strict';

angular
    .module('TR')
    .factory('$exceptionHandler', $exceptionHandler);

function $exceptionHandler(broker, $log, $window, currentUser) {
    const ie9 = /msie 9.0/i.test(navigator.userAgent);
    let success = function() {
        // do nothing
    };
    let skipErrorsLogging = false;
    let digestErrors = 0;
    let errorQueue = [];

    $window.addEventListener('beforeunload', function() {
        skipErrorsLogging = true;
    });

    function error(err, type, msg) {
        errorQueue = [];  //clear the queue if there is a problem - we don't want to kill the client
        $log.warn('Error logging failed');
        $log.log(msg || err);
    }

    (function tick() {
        if (errorQueue.length !== 0) {
            //de-dupe into a dictionary
            const errorDict = {};
            const deduped = [];
            errorQueue.forEach(function(err) {
                if (errorDict[err.errorMessage] == null) {
                    err.count = 0;
                    errorDict[err.errorMessage] = err;
                }
                errorDict[err.errorMessage].count += 1;
            });

            //convert back to an array
            Object.keys(errorDict).forEach(function(msg) {
                deduped.push(errorDict[msg]);
            });

            try {
                $.ajax({
                    type: 'POST',
                    url: 'website/logging/logbatch',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        Messages: deduped.map(function(err) { return JSON.stringify(err); }),
                        LogLevel: ie9 ? 2 : 1 //warn for ie9, otherwise error
                    }),
                    success,
                    error
                });
                errorQueue = [];
            } catch (loggingError) {
                error(loggingError);
            }
        }
        setTimeout(tick, 2000);
    })();

    return function(...args) {
        const exception = args[0];
        const cause = args[1];
        $log.error(...args);
        broker.publish('unblock');
        if (TRPCONFIG.IsBot) { return; }
        try {
            const stackTrace = printStackTrace({ e: exception });
            let errorMessage = exception.toString();
            let user = currentUser.get();

            user = user == null ? 'user is unexpectedly null' : (user.SignedIn ? { Email: user.Email, UtmId: user.UtmId } : user);

            if (skipErrorsLogging) {
                return;
            }

            //note that we can't use $http or $location here because it causes a circular dependency which is a bit annoying
            if (errorMessage.indexOf('$rootScope:infdig') >= 0 ||
                errorMessage.indexOf('$rootScope:inprog') >= 0) {
                digestErrors += 1;
            }
            if (digestErrors > 5) {
                errorMessage = 'Digest loop panic detected';
                skipErrorsLogging = true;
                success = function() {
                    $window.location.href = '/';
                };
            }

            errorQueue.push({
                Message: {
                    userAgent: navigator.userAgent,
                    errorUrl: $window.location.href,
                    errorMessage,
                    stackTrace,
                    cause: (cause || ''),
                    user
                },
                LogLevel: ie9 ? 2 : 1 //warn for ie9, otherwise error
            });
        } catch (loggingError) {
            $log.warn('Error logging failed');
            $log.log(loggingError);
        }
    };
}
})();
